import { render } from "./Horibar.vue?vue&type=template&id=3b79f2d2&scoped=true"
import script from "./Horibar.vue?vue&type=script&lang=js"
export * from "./Horibar.vue?vue&type=script&lang=js"

import "./Horibar.vue?vue&type=style&index=0&id=3b79f2d2&scoped=true&lang=css"

import exportComponent from "/Users/tony/argon2/vue-argon-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b79f2d2"]])

export default __exports__